import { Component, Input, OnChanges, OnInit, SimpleChanges, AfterViewInit, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { CatalogService } from '../../../services/catalog.service';
import Swal from 'sweetalert2';
import { NbThemeService } from '@nebular/theme';
import { UserService } from '../../../services/user.service';
import { LabRecordModel } from '../../../models/lab-record.model';

declare var $: any;

@Component({
    selector: 'ngx-work-pet-physical',
    templateUrl: './physical.component.html',
})
export class PhysicalComponent implements OnInit, AfterViewInit, AfterViewChecked {

    options: any = {};
    themeSubscription: any;

    enviroment_1: string;
    enviroment_2: string;
    enviroment_3: string;

    // options1: any;
    // options2: any;
    private _pet_no: number;

    _profile_types = [
        { profile_type_no: 1, profile_type: 'Weight', visible: true, list: 'pet_profile_weight', options: undefined },
        { profile_type_no: 2, profile_type: 'Temperature', visible: true, list: 'pet_profile_temp', options: undefined },
        { profile_type_no: 36, profile_type: 'Body Condition Score', visible: false, list: 'pet_profile_bcs', options: undefined },
        { profile_type_no: 5, profile_type: 'Blood Pressure', visible: false, list: 'pet_profile_bp', options: undefined },
        { profile_type_no: 3, profile_type: 'Respiration', visible: false, list: 'pet_profile_resp', options: undefined },
        { profile_type_no: 4, profile_type: 'Heart Rate', visible: false, list: 'pet_profile_hr', options: undefined },
        { profile_type_no: 6, profile_type: 'Height', visible: false, list: 'pet_profile_height', options: undefined },
        { profile_type_no: 27, profile_type: 'Fluid Rate', visible: false, list: 'pet_profile_fr', options: undefined },
        { profile_type_no: 29, profile_type: 'Hydration', visible: false, list: 'pet_profile_hydration', options: undefined },
        { profile_type_no: 31, profile_type: 'SP CO2', visible: false, list: 'pet_profile_co2', options: undefined },
    ];

    _labtest_types: {
        low: any;
        high: any;
        test_code: string;
        test_desc: string;
        result_length: number;
        unit: string;
        seq_no: number; 
        visible: boolean | null,
    }[] = []

    set profile_types_invisible(value: any) {
        // this._profile_types = value;
    }

    get profile_types_invisible(): any {
        return this._profile_types.filter(t => !t.visible);
    }

    set profile_types_visible(value: any) {
        // this._profile_types = value;
    }

    get profile_types_visible(): any {
        return this._profile_types.filter(t => t.visible);
    }

    set labtest_types_visible(value: any) {
        // this._profile_types = value;
    }

    get labtest_types_visible(): any {
        return this._labtest_types.filter(t => t.visible);
    }

    @Input() set pet_no(value: number) {
        this._pet_no = value;
        this.petService.getProfileByPetId(this.petService.current_pet_no, 1).then(() => { });
        this.petService.getProfileByPetId(this.petService.current_pet_no, 2).then(() => { });
        this.petService.getEnvironmentByPetId(this.petService.current_pet_no)
            .then(() => {
                // this.enviroment_1 = this.petService.pet_environment.find(t => t.combo_index === 0).combo_text ? this.petService.pet_environment.find(t => t.combo_index === 0).combo_text : '';
                // this.enviroment_2 = this.petService.pet_environment.find(t => t.combo_index === 1).combo_text ? this.petService.pet_environment.find(t => t.combo_index === 1).combo_text : '';
                // this.enviroment_3 = this.petService.pet_environment.find(t => t.combo_index === 2).combo_text ? this.petService.pet_environment.find(t => t.combo_index === 2).combo_text : '';
            });
        this.petService.getTagByPetId(this.petService.current_pet_no).then(() => { });
    }

    get pet_no(): number {
        return this._pet_no;
    }

    constructor(
        private theme: NbThemeService,
        public petService: PetService,
        public catalogService: CatalogService,
        public userService: UserService,
        private route: ActivatedRoute
    ) {
    }

    ngAfterViewChecked(): void {
        if (this.petService.view_physical) {
            console.log(1);
            this.petService.view_physical = false;
            setTimeout(() => {
                let xAxisData1 = [];
                let xAxisData2 = [];
                let data1 = [];
                let data2 = [];

                for (let i = 0; i < this.petService.pet_profile_weight.length; i++) {
                    xAxisData1.push(this.petService.pet_profile_weight[i].profile_date);
                    data1.push(this.petService.pet_profile_weight[i].profile);
                }

                for (let i = 0; i < this.petService.pet_profile_temp.length; i++) {
                    xAxisData2.push(this.petService.pet_profile_temp[i].profile_date);
                    data2.push(this.petService.pet_profile_temp[i].profile);
                }


                let color = this.userService.setBg();
                this.profile_types_visible.find(t => t.profile_type_no === 1).options = {
                    legend: {
                        data: ['weight'],
                        align: 'left',
                    },
                    tooltip: {},
                    xAxis: {
                        data: xAxisData1,
                        silent: false,
                        splitLine: {
                            show: false,
                        },
                    },
                    yAxis: {},
                    series: [
                        {
                            name: 'weight',
                            type: 'line',
                            data: data1,
                            animationDelay: (idx) => idx * 10,
                            color: [color],
                            smooth: true,
                            areaStyle: {}
                        }
                    ],
                    animationEasing: 'elasticOut',
                    animationDelayUpdate: (idx) => idx * 5,
                };

                color = this.userService.setBg();
                this.profile_types_visible.find(t => t.profile_type_no === 2).options = {
                    legend: {
                        data: ['temp'],
                        align: 'left',
                    },
                    tooltip: {},
                    xAxis: {
                        data: xAxisData2,
                        silent: false,
                        splitLine: {
                            show: false,
                        },
                    },
                    yAxis: {},
                    series: [
                        {
                            name: 'temp',
                            type: 'line',
                            data: data2,
                            animationDelay: (idx) => idx * 10,
                            color: [color],
                            smooth: true,
                            areaStyle: {}
                        }
                    ],
                    animationEasing: 'elasticOut',
                    animationDelayUpdate: (idx) => idx * 5,
                };
            }, 150);
        }
    }
 

    ngOnInit() {
        this.petService.changePet
            .subscribe(message => {
                this.pet_no = message;
            });
    }

    ngAfterViewInit(): void {}

    save() {
        Swal.fire({
            title: 'Loading...',
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })

        this.petService.setupPetRabie()
            .then(() => {
                Swal.close();

                Swal.fire({
                  title: 'Information stored correctly',
                  didOpen: () => {
                  },
                })
            });
    }

    add(item: any) {
        this._profile_types.find(t => t.profile_type_no === item.profile_type_no).visible = true;
        this.petService.getProfileByPetId(this.petService.current_pet_no, item.profile_type_no)
            .then(() => {
                let xAxisData1 = [];
                let data1 = [];

                for (let i = 0; i < this.petService[item.list].length; i++) {
                    xAxisData1.push(this.petService[item.list][i].profile_date);
                    data1.push(this.petService[item.list][i].profile);
                }

                let color = this.userService.setBg();
                this.profile_types_visible.find(t => t.profile_type_no === item.profile_type_no).options = {
                    legend: {
                        data: [item.profile_type.toLowerCase()],
                        align: 'left',
                    },
                    tooltip: {},
                    xAxis: {
                        data: xAxisData1,
                        silent: false,
                        splitLine: {
                            show: false,
                        },
                    },
                    yAxis: {},
                    series: [
                        {
                            name: item.profile_type.toLowerCase(),
                            type: 'line',
                            data: data1,
                            animationDelay: (idx) => idx * 10,
                            color: [color],
                            smooth: true,
                            areaStyle: {}
                        }
                    ],
                    animationEasing: 'elasticOut',
                    animationDelayUpdate: (idx) => idx * 5,
                };
            });
    }

    //#region LABTEST
    sel_labtest = '';
    sel_labname = '';
    labdate = null; 

    openLabTestModal() {
        $('#labTestModal').modal('show');
        this.petService.GetLabTestList().then(() => {  
        }); 
    }

    onLabTestChange(event) { 
        Swal.fire({
            title: 'Loading...', 
            didOpen: () => {
            Swal.showLoading()
            },
        })

        this.sel_labtest = event.target.value;
        this.petService.getLabNameList(event.target.value).then(() => {
            Swal.close();
        });
    }

    onLabNameChange(event) {
        Swal.fire({
          title: 'Loading...', 
          didOpen: () => {
            Swal.showLoading()
          },
        })
    
        let fseq_no = event.target.value 
        let lseq_no = this.getNextLabItem(fseq_no);
        this.petService.getLoadTest(this.petService.pet.specie, this.sel_labtest, fseq_no, lseq_no).then(() => { 
            this._labtest_types = this.petService.load_test.map(element => ({
                low: element.low, 
                high: element.high, 
                test_code: element.test_code, 
                test_desc: element.test_desc, 
                result_length: element.result_length, 
                unit: element.unit, 
                seq_no: element.seq_no,
                visible: false,
            }));

            Swal.close();
        });
    }

    getNextLabItem(seq_no: number): any { 
        const index = this.petService.lab_name.findIndex(item => Number(item.seq_no) === Number(seq_no));  
      
        if (index !== -1 && index < this.petService.lab_name.length - 1) {
          const nextItem = this.petService.lab_name[index + 1].seq_no; 
          return nextItem - 1;
        } 
    
        return 0;
    }



    getLabtest() {
        this.petService.labrecord_tables = [];
        this.labtest_types_visible = [] 
        let labtest = this.petService.load_test.filter(t => t.selected === true);
        
        
        for (let i = 0; i < labtest.length; i++) {
            this.petService.GetLabRecordByPetNo(this.petService.current_pet_no, labtest[i].test_code).then((res: LabRecordModel[]) => {
                this.createLabGraph(labtest[i].test_code, res);
                
                if(!res) {
                    Swal.fire({
                        position: "bottom-end",
                        icon: "warning",
                        title: "NO DATA FOUND FOR " + labtest[i].test_desc,
                        showConfirmButton: false,
                        timer: 1000
                    });
                }
            });
        }

        $('#labTestModal').modal('hide'); 
    }

    createLabGraph(testCode: string, labData: LabRecordModel[]) { 
        this._labtest_types.find(t => t.test_code === testCode).visible = true;
        let xAxisData = [];
        let yAxisData = [];
    
        // Populate X-axis (labtest_date) and Y-axis (labtest_val) data

        console.log(`labData` , labData)

        for (let i = 0; i < labData.length; i++) {
            xAxisData.push(labData[i].labtest_date); // X-axis: Dates
            yAxisData.push(labData[i].labtest_val);  // Y-axis: Values
        }
    
         
        let color = this.userService.setBg();
        const lab = this.labtest_types_visible.find(t => t.test_code === testCode);
 
        if (!lab) {
            console.error(`Profile with testCode ${testCode} not found in profile_types_visible.`);
            return;
        }

        lab.options = {
            legend: {
                data: [`Test Code: ${labData[0].test_desc}`],
                align: 'left',
            },
            tooltip: {},
            xAxis: {
                data: xAxisData,
                silent: false,
                splitLine: {
                    show: false,
                },
            },
            yAxis: {},
            series: [
                {
                    name: `Test Code: ${labData[0].test_desc}`,
                    type: 'line',
                    data: yAxisData,
                    animationDelay: (idx) => idx * 10,
                    color: [color],
                    smooth: true,
                    areaStyle: {},
                },
            ],
            animationEasing: 'elasticOut',
            animationDelayUpdate: (idx) => idx * 5,
        }; 
    }

    getTableLabtest(test_code: string) {
        return this.petService.labrecord_tables.find(t => t.test_code === test_code)?.table || []
    }
    //#endregion
}